import React from 'react';
import { ModalProps, ViewStyle } from 'react-native';
import { CalendarItemType } from '../../models';
import NewButton from '../Button/NewButton';
import DeleteModal from '../DeleteModal';
import { styles } from './CalendarItemDeleteConfirmation.presets';

interface CalendarItemRef {
  id: string;
  type: CalendarItemType;
}

export interface Props extends ModalProps {
  /**
   * Callback for modal close/cancel
   */
  onCancel: () => void;

  /**
   * Callback for delete confirmation
   */
  onConfirm: (item: CalendarItemRef) => void;

  /**
   * An optional style override.
   */
  style?: ViewStyle | ViewStyle[];

  /**
   * flag to show or hide modal
   */
  visible: boolean;

  /**
   * The calendar item being deleted
   */
  item: CalendarItemRef;
}

export function CalendarItemDeleteConfirmation(props: Props): JSX.Element {
  const { onCancel, onConfirm, item, visible, ...rest } = props;

  return (
    <DeleteModal
      onCancel={onCancel}
      visible={visible}
      title={`Delete this ${item.type}.`}
      subtitle="Do you want to delete this event?"
      {...rest}
    >
      <NewButton onPress={() => onConfirm(item)} style={styles.buttons}>
        Yes delete this {item.type}.
      </NewButton>
    </DeleteModal>
  );
}
